import { Collection } from "@converse/skeletor";
import DeviceList from "./devicelist.js";

/**
 * @extends {Collection<DeviceList>}
 */
class DeviceLists extends Collection {
    constructor() {
        super();
        this.model = DeviceList;
    }
}

export default DeviceLists;
